// extracted by mini-css-extract-plugin
module.exports = {"process":"Process_process__3Z2EF","items":"Process_items__nF7kU","swipe":"Process_swipe__2ZI2t"};